/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSelector } from '@reduxjs/toolkit';
import TPLMapComponent from "Components/Common/TPLMap";
import { getCities, getNeighborhood, getStates, getZones } from 'live-slices/address/thunk';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Input, Label, Modal, ModalBody, ModalFooter } from 'reactstrap';
import * as Yup from "yup";
import Select from "react-select";
import { useJsApiLoader } from '@react-google-maps/api';

export class AddressModel {
    streetAddress: string;
    type: string;
    coordinates: number[];
    zone: string;
    city: string;
    state: string;
    stateId: string;
    neighborhoodId: string;
    cityId: string;
    zoneId: string;
    isPlaza: boolean;
    plazaMarketName: string;
    shopName: string;
    shopNumber: string;
    neighborhood: string;

    constructor(
        streetAddress: string = "",
        type: string = "",
        coordinates: number[] = [],
        zone: string = "",
        city: string = "",
        state: string = "",
        stateId: string = "",
        neighborhoodId: string = "",
        cityId: string = "",
        zoneId: string = "",
        isPlaza: boolean = true,
        plazaMarketName: string = "",
        shopName: string = "",
        shopNumber: string = "",
        neighborhood: string = "",

    ) {
        this.streetAddress = streetAddress;
        this.type = type;
        this.coordinates = coordinates;
        this.zone = zone;
        this.city = city;
        this.state = state;
        this.stateId = stateId;
        this.neighborhoodId = neighborhoodId;
        this.cityId = cityId;
        this.zoneId = zoneId;
        this.isPlaza = isPlaza;
        this.shopName = shopName;
        this.shopNumber = shopNumber;
        this.plazaMarketName = plazaMarketName;
        this.neighborhood = neighborhood;
    }

    public static copyFromObject(source: any): AddressModel {
        if (source) {
            let obj = new AddressModel();
            if (obj.streetAddress != source.streetAddress) obj.streetAddress = source.streetAddress;
            if (obj.type != source.type) obj.type = source.type;
            if (obj.zone != source.zone) obj.zone = source.zone;
            if (obj.city != source.city) obj.city = source.city;
            if (obj.state != source.state) obj.state = source.state;
            if (obj.stateId != source.stateId) obj.stateId = source.stateId;
            if (obj.neighborhoodId != source.neighborhoodId) obj.neighborhoodId = source.neighborhoodId;
            if (obj.cityId != source.cityId) obj.cityId = source.cityId;
            if (obj.zoneId != source.zoneId) obj.zoneId = source.zoneId;
            if (obj.shopName != source.shopName) obj.shopName = source.shopName;
            if (obj.shopNumber != source.shopNumber) obj.shopNumber = source.shopNumber;
            if (obj.neighborhood != source.neighborhood) obj.neighborhood = source.neighborhood;
            if (obj.plazaMarketName != source.plazaMarketName) obj.plazaMarketName = source.plazaMarketName;
            obj.isPlaza = source.isPlaza;
            obj.coordinates = source.coordinates;
            return obj;
        } else {
            return new AddressModel();
        }
    }

    public static getCoordinates(coordinates: number[]): { lat: number; lng: number } {
        if (coordinates.length) {
            return { lat: coordinates[1], lng: coordinates[0] };
        } else {
            return { lat: 0, lng: 0 };
        }
    }
}

export const BuypassAdressValidationSchema = {
    "stateId": Yup.string()
        .required("State is Required"),
    "cityId": Yup.string()
        .required("City is Required"),
    "zoneId": Yup.string()
        .required("Zone is Required"),
    "shopName": Yup.string()
        .required("Shop Name is required"),
    "shopNumber": Yup.string()
        .required("Shop Number is required"),
    "streetAddress": Yup.string()
        .required("Address details are required"),
         "pinLocationText": Yup.string()
        .required("Shop Pin Location is required"),
    "isPlaza": Yup.boolean(),
    "plazaMarketName": Yup.string().when("isPlaza", {
        is: (isPlaza: boolean) => isPlaza === true,
        then: (schema: any) => Yup.string().required("Plaza Market Name is required"),
        otherwise: (schema: any) => Yup.string().notRequired(),
    })
};

const BuypassAddressSelector = ({ formik }: { formik: any }) => {
    const dispatch: any = useDispatch();
    const stateDataSelector = createSelector(
        (state: any) => state?.Address,
        (states) => states?.states
    );
    const cityDataSelector = createSelector(
        (state: any) => state?.Address,
        (cities) => cities?.cities
    );
    const zoneDataSelector = createSelector(
        (state: any) => state?.Address,
        (zones) => zones?.zones
    );
    const neighborhoodDataSelector = createSelector(
        (state: any) => state?.Address,
        (neighborhood) => neighborhood?.neighborhood
    );
    const stateList = useSelector(stateDataSelector);
    const citiesList = useSelector(cityDataSelector);
    const zonesList = useSelector(zoneDataSelector);
    const neighborhoodList = useSelector(neighborhoodDataSelector);
    const [showDraftModal, setShowDraftModal] = useState(false);
    const [addressState, setAddressState] = useState({
        stateId: "",
        cityId: "",
        neighborhoodId: "",
    });

    useEffect(() => {
        dispatch(getStates());
    }, [dispatch]);

    useEffect(() => {
        const savedStep2 = localStorage.getItem("step2");
        if (savedStep2) {
            try {
                const parsed = JSON.parse(savedStep2);
                const address = parsed.address;
                const keysToCheck = [
                    "stateId", "cityId", "zoneId", "neighborhoodId",
                    "shopName", "shopNumber", "streetAddress", "plazaMarketName"
                ];
                const hasData = keysToCheck.some(
                    key => address?.[key]?.toString().trim() !== ""
                );
                if (hasData) {
                    formik.setValues(parsed);
                } else {
                    console.log("No data to load, skipping localStorage load");
                }
            } catch (err) {
                console.error("step2 JSON parse failed", err);
            }
        }
    }, []);


    useEffect(() => {
        const savedStep2 = localStorage.getItem("step2");
        if (!savedStep2) {
            const keysToCheck = [
                "stateId", "cityId", "zoneId", "neighborhoodId",
                "shopName", "shopNumber", "streetAddress", "plazaMarketName"
            ];
            const address = formik.values.address;
            const hasData = keysToCheck.some(
                key => address?.[key]?.toString().trim() !== ""
            );
            if (hasData) {
                console.log("Saving step2 to localStorage:", formik.values);
                localStorage.setItem("step2", JSON.stringify(formik.values));
            }
        } else {
            localStorage.setItem("step2", JSON.stringify(formik.values));
        }
    }, [JSON.stringify(formik.values)]);

    const { isLoaded } = useJsApiLoader({
        id: 'script-loader',
        googleMapsApiKey: 'AIzaSyCMct0m0boGi9OwuQ43XWH8j5xPce0g6rU',
        libraries: ['places', 'maps'],
    });




    const handleCoordinatesChange = (lat: number, lng: number) => {
        formik.setFieldValue('address.coordinates', [lng, lat]);
    };

    useEffect(() => {
        if (formik) {
            console.log("Formik values:", formik.values.address); // Log formik values
            if (formik.values.address.stateId && formik.values.address.stateId !== addressState.stateId) {
                dispatch(getCities(formik.values.address.stateId));
                if (formik.values.address.cityId && formik.values.address.cityId !== addressState.cityId) {
                    dispatch(getZones(formik.values.address.cityId));
                    setAddressState((prevState) => {
                        return { ...prevState, stateId: formik.values.address.stateId, cityId: formik.values.address.cityId };
                    });
                } else {
                    setAddressState((prevState) => {
                        return { ...prevState, stateId: formik.values.address.stateId };
                    });
                }
            }
        }
    }, [formik]);


const getAddressFromCoordinates = (lat: number, lng: number) => {
  const geocoder = new window.google.maps.Geocoder();
  const latlng = { lat, lng };

  geocoder.geocode({ location: latlng }, (results, status) => {
    if (status === 'OK' && results && results.length > 0) {
      const streetResult = results.find(result =>
        result.types.includes("street_address") ||
        result.types.includes("premise") ||
        result.types.includes("route")
      );

      const finalResult = streetResult || results[0];
      const formattedAddress = finalResult.formatted_address;

      if (formattedAddress && formattedAddress.trim() !== "") {
        if (inputRef.current) inputRef.current.value = formattedAddress;
        formik.setFieldValue("address.pinLocationText", formattedAddress);
        formik.setFieldError("address.pinLocationText", ""); // clear any error
      } else {
        formik.setFieldError("address.pinLocationText", "This field is required");
        if (inputRef.current) inputRef.current.value = "";
      }
    } else {
      console.error('Geocoder failed:', status);
      formik.setFieldError("address.pinLocationText", "This field is required");
    }
  });
};


const sortedStateList = [...stateList].sort((a, b) => a.name.localeCompare(b.name));

    const stateOptions = sortedStateList.map((state: any) => ({
        value: state._id,
        label: state.name,
    }));

    const sortedCityList = [...citiesList].sort((a, b) => a.name.localeCompare(b.name));

    const cityOptions = sortedCityList
        .filter((city: any) => city.sourceId === formik.values.address.stateId)
        .map((city: any) => ({
            value: city._id,
            label: city.name,
        }));

    const zoneOptions = zonesList
        .filter((zone: any) => zone.sourceId === formik.values.address.cityId)
        .map((zone: any) => ({
            value: zone._id,
            label: zone.name,
        }));

    const neighborhoodOptions = neighborhoodList
        ?.filter((neighborhood: any) => neighborhood.zoneId === formik.values.address._id)
        .map((neighborhood: any) => ({
            value: neighborhood._id,
            label: neighborhood.name,
        }));

    const fullAddress = `${formik.values.address.state || ""}, ${formik.values.address.city || ""}, ${formik.values.address.zone || ""}, ${formik.values.address.neighborhood || ""} , ${formik.values.address.streetAddress || ""}`;
    console.log(`new variable: ${fullAddress}`);
    const selectedNeighborhoodValue =
        neighborhoodOptions.find((option: any) => option.value === formik.values.address.neighborhoodId) ||
        (formik.values.address.neighborhoodId && {
            value: formik.values.address.neighborhoodId,
            label: formik.values.address.neighborhood
        }) || null;

    console.log("Selected Neighborhood Value:", selectedNeighborhoodValue);

    // useEffect(() => {
    //     const savedStep2 = localStorage.getItem("step2");
    //     if (savedStep2) {
    //         setShowDraftModal(true);
    //     }
    // }, []);

// useEffect(() => {
//     const step2 = localStorage.getItem("step2");

//     if (step2) {
//         const coords = formik.values.address.coordinates;

//         if (
//             Array.isArray(coords) &&
//             coords.length === 2 &&
//             coords[0] &&
//             coords[1]
//         ) {
//             const [lng, lat] = coords;
//             getAddressFromCoordinates(lat, lng);
//         }
//     } else {
//         if (inputRef.current) {
//             inputRef.current.value = "";
//         }
//     }
// }, [formik.values.address.coordinates]);


    const onLocalDraftContinue = () => {
        const savedData = localStorage.getItem("step2");
        if (savedData) {
            const parsedData = JSON.parse(savedData);
            console.log(parsedData, "localdata");

            formik.setValues({
                ...formik.values,
                ...parsedData,
            });

            setShowDraftModal(false);
        }
    };

    const handleDiscard = () => {
        formik.resetForm();
        localStorage.removeItem("step2");
        setShowDraftModal(false);
    };
    const inputRef = useRef<HTMLInputElement>(null);
    const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);
    const [coordinates, setCoordinates] = useState<{ lat: number; lng: number } | null>(null);
    const hasFetchedAddressRef = useRef(false);

    useEffect(() => {
        const coords = formik.values.address.coordinates;

        if (
            !hasFetchedAddressRef.current &&
            Array.isArray(coords) &&
            coords.length === 2
        ) {
            const [lat, lng] = coords;
            if (lat && lng) {
                getAddressFromCoordinates( lng , lat);
                hasFetchedAddressRef.current = true;
            }
        }
    }, [formik.values.address.coordinates]);



    useEffect(() => {
        if (isLoaded && inputRef.current) {
            autocompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current);

            autocompleteRef.current?.addListener('place_changed', () => {
                const place = autocompleteRef.current?.getPlace();
                const lat = place?.geometry?.location?.lat();
                const lng = place?.geometry?.location?.lng();

                if (lat && lng) {
                    const newCoordinatesArray = [lng, lat];
                    console.log("Selected Coordinates =>", newCoordinatesArray);

                    setCoordinates({ lat, lng }); // ✅ local state
                    formik.setFieldValue('address.coordinates', newCoordinatesArray); // ✅ Formik field
                }
            });

        }
    }, [isLoaded]);

    const mapCoordinates = useMemo(() => {
        const coords = formik.values.address.coordinates;
        if (Array.isArray(coords) && coords.length === 2) {
            return { lat: coords[1], lng: coords[0] }; // [lng, lat] → { lat, lng }
        }
        return null;
    }, [formik.values.address.coordinates]);

    return (
        <React.Fragment>
            <>
                <Modal isOpen={showDraftModal}>
                    <ModalBody>
                        <p>
                            You have unsaved data. Would you like to continue with your previous
                            entries or start fresh?
                        </p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={onLocalDraftContinue}>
                            Continue
                        </Button>
                        <Button color="danger" onClick={handleDiscard}>
                            Discard
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
            <div className='d-grid '>
                <Col xxl={12} md={12}>
                    <div >
                        <div className="formContainer mt-4" data-testing-id="regionInput_AdressFormBox">
                            <Label htmlFor="state" className="form-label">
                                <span className="text-danger">*</span>Province
                            </Label>
                            <Select
                                id="stateId"
                                options={stateOptions}
                                value={stateOptions.find((option: any) => option.value === formik.values.address.stateId)}
                                onChange={(selectedOption: any) => {
                                    if (selectedOption) {
                                        const selectedState = stateList.find((state: any) => state._id === selectedOption.value);
                                        if (selectedState) {
                                            formik.setFieldValue("address.stateId", selectedState._id);
                                            formik.setFieldValue("address.state", selectedState.name);
                                            formik.setFieldValue("address.cityId", "");
                                            formik.setFieldValue("address.city", "");
                                            formik.setFieldValue("address.zoneId", "");
                                            formik.setFieldValue("address.zone", "");
                                            formik.setFieldValue("address.neighborhoodId", "");
                                            formik.setFieldValue("address.neighborhood", "");
                                            formik.setFieldValue("address.streetAddress", "");
                                            dispatch(getCities(selectedState._id));
                                            formik.validateForm();
                                        }
                                    } else {
                                        formik.setFieldValue("address.stateId", "");
                                        formik.setFieldValue("address.state", "");
                                        formik.setFieldValue("address.cityId", "");
                                        formik.setFieldValue("address.zoneId", "");
                                        formik.setFieldValue("address.city", "");
                                        formik.setFieldValue("address.zone", "");
                                        formik.setFieldValue("address.neighborhoodId", "");
                                        formik.setFieldValue("address.neighborhood", "");
                                        formik.setFieldValue("address.streetAddress", "");

                                        formik.validateForm();
                                    }
                                }}
                                placeholder="Search or Select."
                                isClearable
                                className={`form-control ${formik.touched.address?.stateId && formik.errors.address?.stateId ? "is-invalid" : ""
                                    }`}

                            />
                            {formik.touched.address?.stateId && formik.errors.address?.stateId && (
                                <div className="invalid-feedback">{formik.errors.address?.stateId}</div>
                            )}
                        </div>

                        <div className="formContainer mt-4" data-testing-id="cityInput_AdressFormBox">
                            <Label htmlFor="cityId" className="form-label">
                                <span className="text-danger">*</span>City
                            </Label>
                            <Select
                                id="cityId"
                                options={cityOptions}
                                value={
                                    formik.values.address.cityId ? cityOptions.find((option: any) => option.value === formik.values.address.cityId) : null}
                                onChange={(selectedOption: any) => {
                                    if (selectedOption) {
                                        const selectedCity = citiesList.find((city: any) => city._id === selectedOption.value);
                                        if (selectedCity) {
                                            formik.setFieldValue("address.cityId", selectedCity._id);
                                            formik.setFieldValue("address.city", selectedCity.name);
                                            formik.setFieldValue("address.zoneId", "");
                                            formik.setFieldValue("address.neighborhoodId", "");
                                            formik.setFieldValue("address.neighborhood", "");
                                            formik.setFieldValue("address.streetAddress", "");

                                            formik.setFieldValue("address.zone", "");
                                            dispatch(getZones(selectedCity._id));
                                            formik.validateForm();
                                        }
                                    } else {
                                        formik.setFieldValue("address.cityId", "");
                                        formik.setFieldValue("address.city", "");
                                        formik.setFieldValue("address.zoneId", "");
                                        formik.setFieldValue("address.neighborhoodId", "");
                                        formik.setFieldValue("address.neighborhood", "");
                                        formik.setFieldValue("address.streetAddress", "");

                                        formik.setFieldValue("address.zone", "");
                                        formik.validateForm();
                                    }
                                }}
                                placeholder="Search or Select"
                                isDisabled={!formik.values.address.stateId}
                                isClearable
                                className={`form-control ${formik.touched.address?.cityId && formik.errors.address?.cityId ? "is-invalid" : ""
                                    }`}
                            />
                            {formik.touched.address?.cityId && formik.errors.address?.cityId && (
                                <div className="invalid-feedback">{formik.errors.address?.cityId}</div>
                            )}
                        </div>

                        <div className="formContainer mt-4" data-testing-id="districtInput_AdressFormBox">
                            <Label htmlFor="zoneId" className="form-label">
                                <span className="text-danger">*</span>Area
                            </Label>
                            <Select
                                id="zoneId"
                                options={zoneOptions}
                                value={
                                    formik.values.address.zoneId ? zoneOptions.find((option: any) => option.value === formik.values.address.zoneId) : null}
                                onChange={(selectedOption: any) => {
                                    if (selectedOption) {
                                        const selectedZone = zonesList.find((zone: any) => zone._id === selectedOption.value);
                                        if (selectedZone) {
                                            formik.setFieldValue("address.zoneId", selectedZone._id);
                                            formik.setFieldValue("address.zone", selectedZone.name);
                                            formik.setFieldValue("address.neighborhoodId", "");
                                            formik.setFieldValue("address.neighborhood", "");
                                            formik.setFieldValue("address.streetAddress", "");

                                            dispatch(getNeighborhood(selectedZone._id));
                                        }
                                    } else {
                                        formik.setFieldValue("address.zoneId", "");
                                        formik.setFieldValue("address.zone", "");
                                        formik.setFieldValue("address.neighborhoodId", "");
                                        formik.setFieldValue("address.neighborhood", "");
                                        formik.setFieldValue("address.streetAddress", "");

                                    }
                                }}
                                placeholder="Search or Select"
                                isDisabled={!formik.values.address.cityId}
                                isClearable
                                className={`form-control ${formik.touched.address?.zoneId && formik.errors.address?.zoneId ? "is-invalid" : ""
                                    }`}
                            />
                            {formik.touched.address?.zoneId && formik.errors.address?.zoneId && (
                                <div className="invalid-feedback">{formik.errors.address?.zoneId}</div>
                            )}
                        </div>


                        <div className="formContainer mt-4" data-testing-id="neighborhoodInput_AdressFormBox">
                            <Label htmlFor="neighborhoodId" className="form-label">
                                Neighborhood
                            </Label>
                            <Select
                                key={formik.values.address.neighborhoodId || formik.values.address.neighborhood}
                                id="neighborhoodId"
                                options={neighborhoodOptions}
                                value={selectedNeighborhoodValue || null}
                                onChange={(selectedOption: any) => {
                                    if (selectedOption) {
                                        const selectedNeighborhood = neighborhoodList.find(
                                            (neighborhood: any) => neighborhood._id === selectedOption.value
                                        );
                                        if (selectedNeighborhood) {
                                            formik.setFieldValue("address.neighborhoodId", selectedNeighborhood._id);
                                            formik.setFieldValue("address.neighborhood", selectedNeighborhood.name);
                                            formik.setFieldValue("address.streetAddress", "");
                                        }
                                    } else {
                                        formik.setFieldValue("address.neighborhoodId", "");
                                        formik.setFieldValue("address.neighborhood", "");
                                        formik.setFieldValue("address.streetAddress", "");
                                    }
                                }}
                                placeholder="Search or Select"
                                isDisabled={!formik.values.address.zoneId}
                                isClearable
                                className={`form-control ${formik.touched.address?.neighborhoodId && formik.errors.address?.neighborhoodId ? "is-invalid" : ""}`}
                            />
                            {formik.touched.address?.zoneid && formik.errors.address?.Neighborhood && (
                                <div className="invalid-feedback">{formik.errors.address?.Neighborhood}</div>
                            )}
                        </div>



                    </div>

                </Col>



                <div className="live-preview my-2">
                    <h4 className='fw-bold mb-3'>Shop Type</h4>
                    <div className="form-check form-check-inline">
                        <Input
                            className="form-check-input"
                            type="radio"
                            name="address.isPlaza"
                            id="plaza"
                            value="plaza"
                            onChange={() => {
                                formik.setFieldValue("address.isPlaza", true);
                                formik.setFieldValue("address.plazaMarketName", ""); // Clear the plaza name when switching
                            }}
                            checked={formik.values.address.isPlaza}
                            data-testing-Id="plazaOrMarketInput_AdressFormBox"
                        />
                        <Label className="form-check-label" htmlFor="plaza">
                            Plaza or market
                        </Label>
                    </div>

                    <div className="form-check form-check-inline mb-2">
                        <Input
                            className="form-check-input"
                            type="radio"
                            name="address.isPlaza"
                            id="individualShop"
                            value="individualShop"
                            onChange={() => {
                                formik.setFieldValue("address.isPlaza", false);
                            }}
                            checked={!formik.values.address.isPlaza}
                            data-testing-Id="individualShopInput_AdressFormBox"
                        />
                        <Label className="form-check-label" htmlFor="individualShop">
                            Individual Shop
                        </Label>
                    </div>
                </div>

                {formik.values.address.isPlaza && (
                    <Col xxl={12} md={12}>
                        <div className='formContainer '>
                            <Label htmlFor="plazaMarketName" className="form-label">
                                <span className="text-danger">*</span> Plaza Market Name
                            </Label>
                            <Input
                                type="text"
                                name="address.plazaMarketName"
                                className={`form-control ${formik.touched.address?.plazaMarketName && formik.errors.address?.plazaMarketName ? "is-invalid" : ""
                                    }`}
                                id="plazaMarketName"
                                placeholder="Plaza Market Name"
                                onChange={(e) => {
                                    formik.handleChange(e);
                                }}
                                onBlur={formik.handleBlur}
                                value={formik.values.address.plazaMarketName}
                                data-testing-Id="plazeMarketNameInput_AdressFormBox"
                            />
                            {formik.touched.address?.plazaMarketName && formik.errors.address?.plazaMarketName && (
                                <div className="invalid-feedback">{formik.errors.address?.plazaMarketName}</div>
                            )}
                        </div>
                    </Col>
                )}

                <Col xxl={12} md={12}>
                    <div className='formContainer '>

                        <Label htmlFor="shopName" className="form-label">
                            <span className="text-danger">*</span> Shop Name
                        </Label>
                        <Input
                            type="text"
                            name="address.shopName"
                            className={`form-control ${formik.touched.address?.shopName && formik.errors.address?.shopName ? "is-invalid" : ""
                                }`}
                            id="shopName"
                            placeholder="Shop Name"
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                            onBlur={formik.handleBlur}
                            value={formik.values.address.shopName}
                            data-testing-Id="shopNameInput_AdressFormBox"
                        />
                        {formik.touched.address?.shopName && formik.errors.address?.shopName && (
                            <div className="invalid-feedback">{formik.errors.address?.shopName}</div>
                        )}
                    </div>
                </Col>

                <Col xxl={12} md={12}>
                    <div className='formContainer '>
                        <Label htmlFor="shopNumber" className="form-label">
                            <span className="text-danger">*</span> Shop Number
                        </Label>
                        <Input
                            type="text"
                            name="address.shopNumber"
                            className={`form-control ${formik.touched.address?.shopNumber && formik.errors.address?.shopNumber ? "is-invalid" : ""
                                }`}
                            id="shopNumber"
                            placeholder="Shop Number"
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                            onBlur={formik.handleBlur}
                            value={formik.values.address.shopNumber}
                            data-testing-Id="shopNumberInput_AdressFormBox"
                        />
                        {formik.touched.address?.shopNumber && formik.errors.address?.shopNumber && (
                            <div className="invalid-feedback">{formik.errors.address?.shopNumber || formik.submitCount > 0}</div>
                        )}
                    </div>
                </Col>

                <Col xxl={12} md={12}>
                    <div className='formContainer '>
                        <Label htmlFor="streetAddress" className="form-label">
                            <span className="text-danger">*</span> Shop Address
                        </Label>
                        <Input
                            type="text"
                            name="address.streetAddress"
                            className={`form-control ${formik.touched.address?.streetAddress && formik.errors.address?.streetAddress ? "is-invalid" : ""
                                }`}
                            id="streetAddress"
                            placeholder="Shop Address"
                            onChange={(e) => {
                                formik.handleChange(e);
                            }}
                            onBlur={formik.handleBlur}
                            value={formik.values.address.streetAddress}
                            data-testing-Id="shopAdressInput_AdressFormBox"
                        />
                        {formik.touched.address?.streetAddress && formik.errors.address?.streetAddress && (
                            <div className="invalid-feedback">{formik.errors.address?.streetAddress}</div>
                        )}
                    </div>
                </Col>
<Col xxl={12} md={12}>
  <Label htmlFor="pinLocationText" className="form-label fw-bold">
    <span className="text-danger">*</span> Shop Pin Location
  </Label>
  <input
    ref={inputRef}
    data-testing-id="Pin_Location"
    type="text"
    name="address.pinLocationText"
    placeholder="Search location..."
    className={`form-control mb-2 ${
      formik.touched.address?.pinLocationText && formik.errors.address?.pinLocationText ? "is-invalid" : ""
    }`}
    onChange={(e) => {
      const newValue = e.target.value;

      // Update Formik
      formik.setFieldValue("address.pinLocationText", newValue);

      // Update localStorage
      const updatedValues = {
        ...formik.values,
        address: {
          ...formik.values.address,
          pinLocationText: newValue,
        },
      };
      localStorage.setItem("step2", JSON.stringify(updatedValues));
    }}
    onBlur={formik.handleBlur}
    value={formik.values.address.pinLocationText}
  />
  {formik.touched.address?.pinLocationText && formik.errors.address?.pinLocationText && (
    <div className="invalid-feedback">
      {formik.errors.address.pinLocationText}
    </div>
  )}
</Col>

                <TPLMapComponent
                    isLoaded={isLoaded}
                    coordinates={mapCoordinates}
                    onCoordinatesChange={handleCoordinatesChange}
                    fullAddress={formik.values.address.streetAddress}
                    formik={formik}
                    inputRef={inputRef}
                />

            </div>
        </React.Fragment>
    );
};

export default BuypassAddressSelector;